import { useEffect } from "react";

/**
 * iOS Safari + Radix Dialog sometimes leave <body> scroll-locked
 * (data-scroll-locked / overflow:hidden / pointer-events:none) after a dialog
 * closes, freezing the page. This guard clears those stale locks whenever no
 * dialog is actually open. Mounted once at the app root.
 */
export default function ScrollLockGuard() {
  useEffect(() => {
    const anyDialogOpen = () =>
      document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]');

    const unlock = () => {
      if (anyDialogOpen()) return;
      const b = document.body;
      if (b.hasAttribute("data-scroll-locked")) b.removeAttribute("data-scroll-locked");
      if (b.style.overflow === "hidden") b.style.overflow = "";
      if (b.style.pointerEvents === "none") b.style.pointerEvents = "";
      if (b.style.paddingRight) b.style.paddingRight = "";
    };

    // Re-check shortly after any user interaction and on a slow interval.
    const onTouch = () => setTimeout(unlock, 50);
    document.addEventListener("touchstart", onTouch, { passive: true });
    document.addEventListener("click", onTouch, true);
    const iv = setInterval(unlock, 800);

    return () => {
      document.removeEventListener("touchstart", onTouch);
      document.removeEventListener("click", onTouch, true);
      clearInterval(iv);
    };
  }, []);

  return null;
}
